var rich_content_viewer_default = {
  "fontElementMap": "_7GE8a",
  "wrapper": "c0Neg",
  "pluginContainerMobile": "ymUYs",
  "viewer": "_61wh1",
  "android": "zqAkB",
  "rootedTraversedContent": "XTMIj",
  "atomic": "ntNN6",
  "toolbar": "RfppX",
  "block": "WSyAw"
};
export {
  rich_content_viewer_default as default
};
//# sourceMappingURL=rich-content-viewer-scss.js.map
